module.exports = __webpack_public_path__ + "media/images/questions-illustration-dark-e4b57a9a.png";